import { useState } from "react";
import { faqs } from "@/mocks/comicData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/60 py-14 md:py-20">
      <div className="section-x grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.6fr]">
        <div>
          <p className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
            <span className="h-2 w-2 rounded-full bg-primary-500"></span>
            常见问题
          </p>
          <h2 className="mt-2 font-heading text-3xl text-foreground-900 md:text-4xl">关于漫画阅读，你想知道的都在这</h2>
          <p className="mt-3 leading-relaxed text-foreground-600">
            整理了读者最高频的疑问。如果这里没有找到答案，欢迎通过下方联系方式向我们留言，我们会尽快回复。
          </p>
          <button
            type="button"
            onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
            className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
          >
            联系我们
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  open ? "border-primary-300" : "border-background-200/70"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="flex items-center gap-3 text-foreground-900">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm ${
                        open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                      }`}
                    >
                      Q
                    </span>
                    <span className="font-medium">{item.q}</span>
                  </span>
                  <i
                    className={`shrink-0 text-lg text-foreground-500 ${open ? "ri-subtract-line" : "ri-add-line"}`}
                    aria-hidden="true"
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[3.25rem] leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}